import { GlAlert, GlDisclosureDropdown, GlSearchBoxByType, GlLoadingIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import fuzzaldrinPlus from 'fuzzaldrin-plus';
import { reportToSentry } from '~/ci/utils';
import axios from '../../../lib/utils/axios_utils.js?vue3';
import { downloadableArtifactsProjectPipelinePath } from '~/lib/utils/path_helpers/pipelines';
import { __, s__ } from '~/locale';
import Tracking from '../../../tracking/index.js?vue3';
import { TRACKING_CATEGORIES } from '../../constants';
export const i18n = {
    searchPlaceholder: __('Search artifacts'),
    downloadArtifacts: __('Download artifacts'),
    artifactsFetchErrorMessage: s__('Pipelines|Could not load artifacts.'),
    artifactsFetchWarningMessage: s__('Pipelines|Failed to update. Please reload page to update the list of artifacts.'),
    emptyArtifactsMessage: __('No artifacts found')
};
export default {
    name: 'PipelineMultiActions',
    i18n,
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlAlert,
        GlDisclosureDropdown,
        GlSearchBoxByType,
        GlLoadingIcon
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        fullPath: {
            type: String,
            required: true
        },
        pipelineId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            artifacts: [],
            hasError: false,
            isLoading: false,
            searchQuery: '',
            isNewPipeline: false
        };
    },
    computed: {
        hasArtifacts () {
            return this.artifacts.length > 0;
        },
        filteredArtifacts () {
            return this.searchQuery.length > 0 ? fuzzaldrinPlus.filter(this.artifacts, this.searchQuery, {
                key: 'name'
            }) : this.artifacts;
        },
        items () {
            return this.filteredArtifacts.map(({ name, path })=>({
                    text: name,
                    href: path,
                    extraAttrs: {
                        download: '',
                        rel: 'nofollow',
                        'data-testid': 'artifact-item'
                    }
                }));
        }
    },
    watch: {
        pipelineId () {
            this.isNewPipeline = true;
        }
    },
    methods: {
        fetchArtifacts () {
            // refactor tracking based on action once this dropdown supports
            // actions other than artifacts
            this.track('click_artifacts_dropdown', {
                label: TRACKING_CATEGORIES.table
            });
            // Preserve the last good list and present it if a request fails
            const oldArtifacts = [
                ...this.artifacts
            ];
            this.artifacts = [];
            this.hasError = false;
            this.isLoading = true;
            const endpoint = downloadableArtifactsProjectPipelinePath(this.fullPath, this.pipelineId, {
                format: 'json'
            });
            return axios.get(endpoint).then(({ data })=>{
                this.artifacts = data.artifacts;
                this.isNewPipeline = false;
            }).catch((err)=>{
                this.hasError = true;
                if (!this.isNewPipeline) {
                    this.artifacts = oldArtifacts;
                }
                reportToSentry(this.$options.name, err);
            }).finally(()=>{
                this.isLoading = false;
            });
        },
        onDisclosureDropdownShown () {
            this.fetchArtifacts();
        },
        onDisclosureDropdownHidden () {
            this.searchQuery = '';
        }
    }
};
